import * as React from 'react'

import Icon from 'components/Icon'

import classNames from 'classnames'
import './Heading.scss'

interface HeadingProps {
  subHeading?: string | JSX.Element
  level?: number
  borderBottom?: boolean
  iconTop?: boolean
  centered?: boolean
  huge?: boolean
  extraBold?: boolean
  hideSubHeadingMobile?: boolean
  children: string | JSX.Element | Array<JSX.Element | string> | null
  backgroundImage?: string
  icon?: JSX.Element
  alternate?: boolean
  thin?: boolean
  timelineHeading?: boolean
}

const Heading: React.FC<HeadingProps> = props => {
  const {
    borderBottom,
    iconTop,
    centered,
    huge,
    extraBold,
    backgroundImage,
    hideSubHeadingMobile,
    subHeading,
    icon,
    level,
    children,
    alternate,
    thin,
    timelineHeading,
  } = props

  const HeadingTag = (`h${level}` as unknown) as keyof JSX.IntrinsicElements
  const SubHeadingTag = (`h${(level as number) +
    1}` as unknown) as keyof JSX.IntrinsicElements

  const headingClassName = classNames({
    'srprs-heading': true,
    'has-borderBottom': !!borderBottom,
    'has-iconTop': !!iconTop,
    'is-centered': !!centered,
    'is-huge': !!huge,
    'is-extra-bold': !!extraBold,
    'has-background': !!backgroundImage,
    'is-alternative': !!alternate,
    'is-thin': !!thin,
    'is-timeline': !!timelineHeading,
  })

  const subHeadingClassName = classNames(
    'srprs-heading',
    'type-subline',
    centered ? 'is-centered' : '',
    hideSubHeadingMobile ? 'hide-subHeading-mobile' : '',
  )
  const style = backgroundImage
    ? { backgroundImage: `url(${backgroundImage})` }
    : undefined

  return (
    <React.Fragment>
      {subHeading && (
        <SubHeadingTag className={subHeadingClassName}>
          {subHeading}
        </SubHeadingTag>
      )}
      <HeadingTag className={headingClassName} {...{ style }}>
        {icon && <Icon icon={icon} />}
        {children}
      </HeadingTag>
    </React.Fragment>
  )
}

Heading.defaultProps = {
  level: 1,
  borderBottom: false,
}

export default Heading
